<template>
  <div class="no-data text-center">
    <Icon :type="icon" :size="50" color="#c4c4c4"/>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'md-sad'
    },
    message: {
      type: String,
      default: 'No Data'
    }
  }
}
</script>
